function urlify(text) {
  var urlRegex = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])(?=[^"]*(?:"[^"]*"[^"]*)*$)/gim
  return (text || "").replace(urlRegex, function (url) {
    return '<a target="_blank" href="' + url + '">' + url + "</a>"
  })
}

export default urlify
